import { FormatsService } from '../formats.service';
import { TechFormatNumer, TechGetDecimalInfo, Utils } from '../utils';
import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { getCurrencySymbol } from '@angular/common';

@Pipe({
  name: 'trCurrency',
})
@Injectable({ providedIn: 'root' })
export class CurrencyPipe implements PipeTransform {
  constructor(private formats: FormatsService) {}

  transform(value: number, currencyCode: string, digitsInfo?: string): string {
    if (!Utils.isValue(value)) return null;

    //digitsInfo = Utils.isValue(digitsInfo) ? digitsInfo : Default.digitsInfo;

    //const locale: string = this.formats.locale;

    const currencySymbol = Utils.checkCustomCurrencySymbol(
      currencyCode,
      this.formats.customCurrencySymbols
    );

    const curr = getCurrencySymbol(currencyCode, 'narrow');

    const decimalPlaces = TechGetDecimalInfo(digitsInfo);

    // Redondear el número a la cantidad deseada de decimales
    const roundedNumber = value.toFixed(decimalPlaces);

    const num = TechFormatNumer(
      roundedNumber,
      this.formats.decimalCharacter,
      this.formats.digitGroupSeparator
    );

    if (Utils.isValue(this.formats.customCurrencyPosition)) {
      const txt = '{0} {1}';
      if (this.formats.customCurrencyPosition === 'L') {
        return Utils.formatString(txt, [currencySymbol, num]);
      } else if (this.formats.customCurrencyPosition === 'R') {
        return Utils.formatString(txt, [num, currencySymbol]);
      }
    } else {
      const txt = '{0} {1}';
      return Utils.formatString(txt, [num, curr]);
    }
  }
}
